(function () {
  'use strict';

  /**
   * Convert an ISO 3166-1 alpha-2 code to its emoji flag.
   * Works by offsetting each letter into the Regional Indicator Symbol range.
   */
  function isoToFlag(code) {
    if (!code || code.length !== 2) return '';
    var offset = 0x1F1E6 - 65; // 'A' = 65
    var first = code.codePointAt(0);
    var second = code.codePointAt(1);
    return String.fromCodePoint(first + offset) + String.fromCodePoint(second + offset);
  }

  var root = document.querySelector('.cs');
  if (!root) return;

  var trigger = root.querySelector('.cs__trigger');
  var panel = root.querySelector('.cs__panel');
  var search = root.querySelector('.cs__search');
  var list = root.querySelector('.cs__list');
  var flagEl = root.querySelector('.cs__flag');
  var labelEl = root.querySelector('.cs__label');
  var countryInput = root.querySelector('.cs__country-input');
  var locForm = root.querySelector('.cs__loc-form');

  // Country data injected by Liquid as a JSON script block
  var countries = [];
  try {
    var dataEl = document.getElementById('avora-cs-data');
    if (dataEl) countries = JSON.parse(dataEl.textContent);
  } catch (e) { /* silent */ }

  var selectedCode = root.dataset.selected || '';

  function render() {
    list.innerHTML = '';
    countries.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'cs__option';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', c.code === selectedCode);
      li.dataset.code = c.code;
      li.dataset.name = c.name.toLowerCase();
      li.innerHTML =
        '<span class="cs__option-flag">' + isoToFlag(c.code) + '</span>' +
        '<span class="cs__option-name">' + c.name + '</span>';
      li.addEventListener('click', function () { select(c); });
      list.appendChild(li);
    });
  }

  function select(country) {
    selectedCode = country.code;
    flagEl.textContent = isoToFlag(country.code);
    labelEl.textContent = country.code;
    root.dataset.selected = country.code;

    list.querySelectorAll('.cs__option').forEach(function (li) {
      li.setAttribute('aria-selected', li.dataset.code === country.code);
    });

    close();

    // Submit Shopify localization form
    if (countryInput && locForm) {
      countryInput.value = country.code;
      locForm.submit();
    }
  }

  function open() {
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    search.value = '';
    filter('');
    setTimeout(function () { search.focus(); }, 50);
  }

  function close() {
    panel.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
  }

  function filter(query) {
    var q = query.toLowerCase().trim();
    var any = false;

    list.querySelectorAll('.cs__option').forEach(function (li) {
      var match = !q || li.dataset.name.includes(q);
      li.classList.toggle('is-hidden', !match);
      if (match) any = true;
    });

    var empty = list.querySelector('.cs__empty');
    if (!any && !empty) {
      empty = document.createElement('li');
      empty.className = 'cs__empty';
      empty.textContent = 'No countries found';
      list.appendChild(empty);
    } else if (any && empty) {
      empty.remove();
    }
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    panel.classList.contains('is-open') ? close() : open();
  });

  search.addEventListener('input', function (e) { filter(e.target.value); });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      close();
      trigger.focus();
    }
  });

  render();
})();
